import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { style: {"margin-top":"10px"} }
const _hoisted_2 = {
  class: "table table-condensed table-embed node-details-simple",
  style: {"margin-bottom":"0"}
}
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  "data-test": "description",
  class: "value text-strong",
  colspan: "4"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = {
  class: "value text-strong",
  colspan: "4"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { class: "key" }
const _hoisted_9 = {
  "data-test": "attributes",
  class: "value"
}
const _hoisted_10 = {
  key: 0,
  class: "key"
}
const _hoisted_11 = {
  key: 1,
  class: "value",
  "data-test": "os-data"
}
const _hoisted_12 = { class: "key" }
const _hoisted_13 = { key: 3 }
const _hoisted_14 = { class: "key" }
const _hoisted_15 = {
  class: "",
  colspan: "3"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "nodetags" }
const _hoisted_18 = { class: "key setting" }
const _hoisted_19 = {
  class: "setting",
  colspan: "3"
}
const _hoisted_20 = { class: "value" }
const _hoisted_21 = { class: "key namespace" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  colspan: "3",
  class: "text-muted"
}
const _hoisted_24 = ["data-test"]
const _hoisted_25 = {
  class: "setting",
  colspan: "3"
}
const _hoisted_26 = ["data-test"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_node_status = _resolveComponent("node-status")!
  const _component_node_filter_link = _resolveComponent("node-filter-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("table", _hoisted_2, [
      _createElementVNode("tbody", null, [
        (_ctx.attributes.description)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
              _createElementVNode("td", _hoisted_4, _toDisplayString(_ctx.attributes.description), 1)
            ]))
          : _createCommentVNode("", true),
        (!_ctx.authrun)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
              _createElementVNode("td", _hoisted_6, [
                _cache[0] || (_cache[0] = _createElementVNode("i", { class: "glyphicon glyphicon-ban-circle" }, null, -1)),
                _createTextVNode(" " + _toDisplayString(_ctx.$t("node.access.not-runnable.message")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.attributes['ui:status:icon'] || _ctx.attributes['ui:status:text'])
          ? (_openBlock(), _createElementBlock("tr", _hoisted_7, [
              _createElementVNode("td", _hoisted_8, _toDisplayString(_ctx.$t("node.metadata.status")), 1),
              _createElementVNode("td", _hoisted_9, [
                _createVNode(_component_node_status, {
                  node: { attributes: _ctx.attributes },
                  "show-text": true
                }, null, 8, ["node"])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("tr", null, [
          (_ctx.hasOsData())
            ? (_openBlock(), _createElementBlock("td", _hoisted_10, _toDisplayString(_ctx.$t("node.metadata.os")), 1))
            : _createCommentVNode("", true),
          (_ctx.hasOsData())
            ? (_openBlock(), _createElementBlock("td", _hoisted_11, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredAttrs, (attr) => {
                  return (_openBlock(), _createBlock(_component_node_filter_link, {
                    key: attr,
                    style: {"margin-right":"0.5em"},
                    "filter-key": attr,
                    "filter-val": _ctx.attributes[attr],
                    class: _normalizeClass({
                'text-parenthetical': attr === 'osFamily' || attr === 'osArch',
              }),
                    onNodefilterclick: _ctx.filterClick
                  }, null, 8, ["filter-key", "filter-val", "class", "onNodefilterclick"]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.useDefaultColumns)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.$t("node.metadata.username-at-hostname")), 1),
                _createElementVNode("td", null, [
                  (_ctx.attributes.username)
                    ? (_openBlock(), _createBlock(_component_node_filter_link, {
                        key: 0,
                        "filter-key": "username",
                        "filter-val": _ctx.attributes.username,
                        "data-testid": "node-attribute-link-username",
                        onNodefilterclick: _ctx.filterClick
                      }, null, 8, ["filter-val", "onNodefilterclick"]))
                    : _createCommentVNode("", true),
                  _cache[1] || (_cache[1] = _createElementVNode("span", { class: "atsign" }, "@", -1)),
                  (_ctx.attributes.hostname)
                    ? (_openBlock(), _createBlock(_component_node_filter_link, {
                        key: 1,
                        "filter-key": "hostname",
                        "filter-val": _ctx.attributes.hostname,
                        "data-testid": "node-attribute-link-hostname",
                        onNodefilterclick: _ctx.filterClick
                      }, null, 8, ["filter-val", "onNodefilterclick"]))
                    : _createCommentVNode("", true)
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        (_ctx.tags && _ctx.tags.length > 0)
          ? (_openBlock(), _createElementBlock("tr", _hoisted_13, [
              _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.$t("node.metadata.tags")), 1),
              _createElementVNode("td", _hoisted_15, [
                (_ctx.tags)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                      _createElementVNode("span", _hoisted_17, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tags, (tag) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: tag,
                            class: "label label-muted"
                          }, [
                            _createTextVNode(_toDisplayString(tag) + " ", 1),
                            _createVNode(_component_node_filter_link, {
                              "filter-key": "tags",
                              "filter-val": tag,
                              class: "textbtn textbtn-info textbtn-saturated hover-action",
                              onNodefilterclick: _ctx.filterClick
                            }, {
                              default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
                                _createElementVNode("i", { class: "glyphicon glyphicon-plus text-success" }, null, -1)
                              ]))]),
                              _: 1
                            }, 8, ["filter-val", "onNodefilterclick"]),
                            (_ctx.showExcludeFilterLinks)
                              ? (_openBlock(), _createBlock(_component_node_filter_link, {
                                  key: 0,
                                  exclude: true,
                                  "filter-key": "tags",
                                  "filter-val": tag,
                                  class: "text-danger textbtn textbtn-info textbtn-saturated hover-action",
                                  onNodefilterclick: _ctx.filterClick
                                }, {
                                  default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                    _createElementVNode("i", { class: "glyphicon glyphicon-minus text-danger" }, null, -1)
                                  ]))]),
                                  _: 1
                                }, 8, ["filter-val", "onNodefilterclick"]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("tbody", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.attributesWithNoNamespaces, (value, attr) => {
          return (_openBlock(), _createElementBlock("tr", {
            key: attr,
            class: "hover-action-holder"
          }, [
            _createElementVNode("td", _hoisted_18, [
              _createVNode(_component_node_filter_link, {
                "filter-key": attr as string,
                "filter-val": ".*",
                onNodefilterclick: _ctx.filterClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(attr) + ": ", 1)
                ]),
                _: 2
              }, 1032, ["filter-key", "onNodefilterclick"])
            ]),
            _createElementVNode("td", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createTextVNode(_toDisplayString(_ctx.attributes[attr]) + " ", 1),
                _createVNode(_component_node_filter_link, {
                  "filter-key": attr as string,
                  "filter-val": value,
                  class: "textbtn textbtn-info textbtn-saturated hover-action",
                  onNodefilterclick: _ctx.filterClick
                }, {
                  default: _withCtx(() => [...(_cache[4] || (_cache[4] = [
                    _createElementVNode("i", { class: "glyphicon glyphicon-plus text-success" }, null, -1)
                  ]))]),
                  _: 1
                }, 8, ["filter-key", "filter-val", "onNodefilterclick"]),
                (_ctx.showExcludeFilterLinks)
                  ? (_openBlock(), _createBlock(_component_node_filter_link, {
                      key: 0,
                      exclude: true,
                      "filter-key": attr as string,
                      "filter-val": value,
                      class: "text-danger textbtn textbtn-info textbtn-saturated hover-action",
                      onNodefilterclick: _ctx.filterClick
                    }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("i", { class: "glyphicon glyphicon-minus text-danger" }, null, -1)
                      ]))]),
                      _: 1
                    }, 8, ["filter-key", "filter-val", "onNodefilterclick"]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        }), 128))
      ]),
      (_ctx.useNamespace)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.attributeNamespaces, (namespace, idx) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: `tr-${idx}`
            }, [
              _createElementVNode("tr", null, [
                _createElementVNode("td", _hoisted_21, [
                  _createElementVNode("a", {
                    href: "#",
                    role: "button",
                    class: _normalizeClass([{ active: _ctx.uiNs[namespace.ns] }, "textbtn textbtn-muted textbtn-saturated"]),
                    onClick: ($event: any) => (_ctx.toggleNs(namespace.ns))
                  }, [
                    _createTextVNode(_toDisplayString(namespace.ns) + " ", 1),
                    _cache[6] || (_cache[6] = _createElementVNode("i", { class: "auto-caret" }, null, -1))
                  ], 10, _hoisted_22)
                ]),
                _createElementVNode("td", _hoisted_23, _toDisplayString(namespace.values.length), 1)
              ]),
              _createElementVNode("tbody", {
                class: _normalizeClass(["subattrs collapse collapse-expandable", { in: _ctx.uiNs[namespace.ns] }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(namespace.values, (nsattr) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: nsattr.name,
                    class: "hover-action-holder"
                  }, [
                    _createElementVNode("td", {
                      class: "key setting",
                      "data-test": nsattr.name
                    }, [
                      _createVNode(_component_node_filter_link, {
                        "filter-key": nsattr.name,
                        "filter-val": ".*",
                        onNodefilterclick: _ctx.filterClick
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(nsattr.shortname) + ": ", 1)
                        ]),
                        _: 2
                      }, 1032, ["filter-key", "onNodefilterclick"])
                    ], 8, _hoisted_24),
                    _createElementVNode("td", _hoisted_25, [
                      _createElementVNode("div", {
                        class: "value",
                        "data-test": `${nsattr.name}-value`
                      }, [
                        _createTextVNode(_toDisplayString(nsattr.value) + " ", 1),
                        _createVNode(_component_node_filter_link, {
                          "filter-key": nsattr.name,
                          "filter-val": nsattr.value,
                          class: "textbtn textbtn-info textbtn-saturated hover-action",
                          onNodefilterclick: _ctx.filterClick
                        }, {
                          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                            _createElementVNode("i", { class: "glyphicon glyphicon-search" }, null, -1)
                          ]))]),
                          _: 1
                        }, 8, ["filter-key", "filter-val", "onNodefilterclick"]),
                        (_ctx.showExcludeFilterLinks)
                          ? (_openBlock(), _createBlock(_component_node_filter_link, {
                              key: 0,
                              exclude: true,
                              "filter-key": nsattr.name,
                              "filter-val": nsattr.value,
                              class: "text-danger textbtn textbtn-info textbtn-saturated hover-action",
                              onNodefilterclick: _ctx.filterClick
                            }, {
                              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                _createElementVNode("i", { class: "glyphicon glyphicon-zoom-out text-danger" }, null, -1)
                              ]))]),
                              _: 1
                            }, 8, ["filter-key", "filter-val", "onNodefilterclick"]))
                          : _createCommentVNode("", true)
                      ], 8, _hoisted_26)
                    ])
                  ]))
                }), 128))
              ], 2)
            ], 64))
          }), 128))
        : _createCommentVNode("", true)
    ])
  ]))
}